export const getStaticAssetUrl = (assetPath) => {
  if (!assetPath.startsWith('/')) {
    throw new Error('assetPath should start with `/`');
  }
  return `https://${FRONT_CDN_HOST}${assetPath}`;
};

export const getPaybisIconsUrl = (assetPath) => {
  if (!assetPath.startsWith('/')) {
    throw new Error('assetPath should start with `/`');
  }
  return `${PAYBIS_ICONS_BASE_URL}${assetPath}`;

};